var _a;
// this file is a copy of the v3 one, both need to be always in sync
// https://github.com/cloudscape-design/components/blob/main/src/internal/plugins/api.ts
import { DrawersController } from './controllers/drawers';
var storageKey = Symbol.for('awsui-plugin-api');
function findUpApi(currentWindow) {
    var _a;
    try {
        if ((_a = currentWindow) === null || _a === void 0 ? void 0 : _a[storageKey]) {
            return currentWindow[storageKey];
        }
        if (!currentWindow || currentWindow.parent === currentWindow) {
            // When the window has no more parents, it references itself
            return undefined;
        }
        return findUpApi(currentWindow.parent);
    }
    catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
}
export function loadApi() {
    if (typeof window === 'undefined') {
        return installApi({});
    }
    var win = window;
    var existingApi = findUpApi(win);
    win[storageKey] = installApi((existingApi !== null && existingApi !== void 0 ? existingApi : {}));
    return win[storageKey];
}
export var awsuiPlugins = (_a = loadApi(), _a.awsuiPlugins), awsuiPluginsInternal = _a.awsuiPluginsInternal;
function installApi(api) {
    var _a, _b;
    api.awsuiPlugins = (_a = api.awsuiPlugins, (_a !== null && _a !== void 0 ? _a : {}));
    api.awsuiPluginsInternal = (_b = api.awsuiPluginsInternal, (_b !== null && _b !== void 0 ? _b : {}));
    var appLayoutDrawers = new DrawersController();
    api.awsuiPlugins.appLayout = appLayoutDrawers.installPublic(api.awsuiPlugins.appLayout);
    api.awsuiPluginsInternal.appLayout = appLayoutDrawers.installInternal(api.awsuiPluginsInternal.appLayout);
    return api;
}
//# sourceMappingURL=api.js.map